/** Strings of the project Planner tab (conversation with Radim, typed or by voice). */
export const projReviewEn = {
  projReview: {
    loadListFailed: "Couldn't load the conversations.",
    startFailed: "Couldn't start the conversation.",
    intro:
      "Talk to Radim about whatever you need: come up with ideas, rework or open tickets, plan them for Metoděj, or go through the open ones. Everything he does is listed with a button to put it back.",
    start: "Start a conversation",
    talkByVoice: "Talk by voice",
    openInLair: "Open in lair",
    lairHelp:
      "Nothing opened? Install lair (<install>{{command}}</install>) or run <run>{{runCommand}}</run>.",
    loading: "Loading…",
    noConversations: "No conversations yet.",
    lairAllProjects: "lair, all projects",
    stillOpen: "still open",
    noChanges: "no changes",
    changesStanding: "{{standing}} of {{total}} changes standing",
    loadFailed: "Couldn't load the conversation.",
    noAnswer: "He didn't answer — try again.",
    endFailed: "Couldn't end the conversation.",
    revertAllFailed: "Couldn't revert the conversation.",
    toVoiceFailed: "Couldn't switch to voice.",
    toTextFailed: "Couldn't switch back to writing.",
    allConversations: "← All conversations",
    ending: "Ending…",
    end: "End the conversation",
    lookingBack: "Looking back",
    whatRadimShouldChange: "What Radim should change →",
    you: "You",
    youLabel: "You: ",
    thinking: "Radim is thinking…",
    globalNote:
      "A conversation across all projects, held in lair. Shown here is only what it changed in this project.",
    consoleNote: "This conversation runs in lair. Continue it there.",
    inputPlaceholder: "Tell Radim what you want to work on…",
    send: "Send",
    switchToVoice: "Switch to voice",
    closed: "This conversation is closed.",
    gradingFailed: "Couldn't load the call's grading.",
    transcriptFailed: "Couldn't load the transcript.",
    loadingTranscript: "Loading the transcript…",
    voiceMeeting: "This meeting happened over voice.",
    heardSoFar: "What he's heard so far",
    nothingSaid: "Nothing said yet.",
    micFailed: "Couldn't reach the microphone or the call.",
    callDropped: "The call dropped.",
    outOfCredits:
      "ElevenLabs has run out of credits, so Radim can't talk until someone tops them up. The admins got an email; the review picks up where it stopped.",
    endCallFailed: "Couldn't end the call cleanly.",
    unmute: "Unmute",
    mute: "Mute",
    hangUp: "Hang up and carry on in writing",
    ready:
      "Radim is ready — join with your microphone. The call happens right here, nothing to open elsewhere.",
    join: "Join the call",
    backToWriting: "Back to writing",
    connecting: "Connecting…",
    callEnded: "Call ended.",
    rejoin: "Rejoin",
    tryAgain: "Try again",
    gaps: {
      should_close: "looks finished",
      no_assignee: "no assignee",
      no_status: "no status",
      no_release: "no release",
      no_estimate: "no estimate",
      overdue: "overdue",
      blocked: "blocked",
      silent: "gone quiet",
      no_discussion: "no discussion",
    },
    workItems: "Work items",
    progress: "{{done}} of {{total}}",
    spentSoFar: "Spent so far: {{spend}}",
    spent: "Spent: {{spend}}",
    callMinutes: " · {{count}} min call",
    whatChanged: "What he changed",
    reverting: "Reverting…",
    revertAll: "Revert all",
    nothingYet: "Nothing yet.",
    revertFailed: "Couldn't put that back.",
    putBack: "Put back",
    putBackBy: "Put back by {{name}}",
    revert: "Revert",
    cantUndo: "Can't be undone",
  },
};

export const projReviewCs: typeof projReviewEn = {
  projReview: {
    loadListFailed: "Konverzace se nepodařilo načíst.",
    startFailed: "Konverzaci se nepodařilo zahájit.",
    intro:
      "Mluvte s Radimem o čemkoli potřebujete: vymýšlejte nápady, přepracovávejte nebo zakládejte tikety, plánujte je pro Metoděje nebo projděte otevřené. Všechno, co udělá, je vypsané s tlačítkem, které to vrátí zpět.",
    start: "Zahájit konverzaci",
    talkByVoice: "Mluvit hlasem",
    openInLair: "Otevřít v lairu",
    lairHelp:
      "Nic se neotevřelo? Nainstalujte lair (<install>{{command}}</install>) nebo spusťte <run>{{runCommand}}</run>.",
    loading: "Načítání…",
    noConversations: "Zatím žádné konverzace.",
    lairAllProjects: "lair, všechny projekty",
    stillOpen: "stále otevřená",
    noChanges: "žádné změny",
    changesStanding: "platných změn: {{standing}} z {{total}}",
    loadFailed: "Konverzaci se nepodařilo načíst.",
    noAnswer: "Neodpověděl — zkuste to znovu.",
    endFailed: "Konverzaci se nepodařilo ukončit.",
    revertAllFailed: "Konverzaci se nepodařilo vrátit zpět.",
    toVoiceFailed: "Přepnutí na hlas se nepodařilo.",
    toTextFailed: "Přepnutí zpět na psaní se nepodařilo.",
    allConversations: "← Všechny konverzace",
    ending: "Ukončování…",
    end: "Ukončit konverzaci",
    lookingBack: "Ohlédnutí",
    whatRadimShouldChange: "Co by měl Radim změnit →",
    you: "Vy",
    youLabel: "Ty: ",
    thinking: "Radim přemýšlí…",
    globalNote:
      "Konverzace napříč všemi projekty vedená v lairu. Zobrazuje se jen to, co změnila v tomto projektu.",
    consoleNote: "Tato konverzace běží v lairu. Pokračujte v ní tam.",
    inputPlaceholder: "Řekněte Radimovi, na čem chcete pracovat…",
    send: "Odeslat",
    switchToVoice: "Přepnout na hlas",
    closed: "Tato konverzace je uzavřená.",
    gradingFailed: "Hodnocení hovoru se nepodařilo načíst.",
    transcriptFailed: "Přepis se nepodařilo načíst.",
    loadingTranscript: "Načítání přepisu…",
    voiceMeeting: "Tato schůzka proběhla hlasem.",
    heardSoFar: "Co zatím slyšel",
    nothingSaid: "Zatím nic nezaznělo.",
    micFailed: "Nepodařilo se získat mikrofon nebo spojení s hovorem.",
    callDropped: "Hovor se přerušil.",
    outOfCredits:
      "ElevenLabs došly kredity, takže Radim nemůže mluvit, dokud je někdo nedobije. Administrátoři dostali e-mail; porada naváže tam, kde skončila.",
    endCallFailed: "Hovor se nepodařilo čistě ukončit.",
    unmute: "Zapnout mikrofon",
    mute: "Ztlumit mikrofon",
    hangUp: "Zavěsit a pokračovat psaním",
    ready:
      "Radim je připravený — připojte se s mikrofonem. Hovor probíhá přímo tady, nic dalšího se otevírat nemusí.",
    join: "Připojit se k hovoru",
    backToWriting: "Zpět k psaní",
    connecting: "Připojování…",
    callEnded: "Hovor skončil.",
    rejoin: "Připojit se znovu",
    tryAgain: "Zkusit znovu",
    gaps: {
      should_close: "vypadá hotově",
      no_assignee: "bez řešitele",
      no_status: "bez stavu",
      no_release: "bez vydání",
      no_estimate: "bez odhadu",
      overdue: "po termínu",
      blocked: "blokováno",
      silent: "ticho po pěšině",
      no_discussion: "bez diskuze",
    },
    workItems: "Tikety",
    progress: "{{done}} z {{total}}",
    spentSoFar: "Dosud utraceno: {{spend}}",
    spent: "Utraceno: {{spend}}",
    callMinutes: " · hovor {{count}} min",
    whatChanged: "Co změnil",
    reverting: "Vracení…",
    revertAll: "Vrátit vše",
    nothingYet: "Zatím nic.",
    revertFailed: "Nepodařilo se to vrátit zpět.",
    putBack: "Vráceno zpět",
    putBackBy: "Vrátil zpět: {{name}}",
    revert: "Vrátit",
    cantUndo: "Nelze vrátit zpět",
  },
};
